<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex  m-3 justify-content-between">
        <p class="fw-bold">
          سنجش اثرات/  <span  v-if="status">
          نهاده
        </span>
          <span v-else>
            نماگر
          </span>
        </p>
        <div>
          <div @click.prevent="status=!status"  class="d-flex changer">
            <p  v-if="status">
              نهاده
            </p>
            <p v-else>
              نماگر
            </p>

            <p v-if="status">
              نماگر
            </p>
            <p v-else>
              نهاده
            </p>
          </div>

        </div>
      </div>
      <hr class="mb-2">
      <div class="d-flex justify-content-end">

        <div class="d-flex"  >
          <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"  v-if="modalMessage" @click="modalMessageShowModal=true">   دلایل عدم تایید</a>
        </div>

      </div>
      <center>
        <div class="alert alert-info" style="width: 10vw;" v-if="modalMessageShowModal" @click="modalMessageShowModal=true">دلایل عدم تایید</div>
        <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>دلایل عدم تایید</p>
            <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
          </div>
          <div>
            <div class="bg-white w-100 rounded p-3 text-right">
              <p>{{modalMessageShow}}</p>
            </div>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="modalMessageShowModal=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
            </div>
          </div>
        </div>
      </center>
      <center   v-if="step===0">
        <div class="alert alert-info w-75" >
          در انتظار تکمیل / بروزرسانی کاربرگ توسط {{$route.params.title}}

        </div>
      </center>
      <center v-else>
        <div v-if="status_show" class="alert alert-success ">
          تایید نهایی   شرکت {{$route.params.title}} انجام شد
        </div>
      </center>
     <center>
       <Input v-if="status && step!==0" class="mt-3"/>
       <Photographer v-else-if="!status && step!==0" class="mt-3"/>

     </center>
      <div    class="d-flex align-items-center justify-content-center mb-3">

        <a v-if="status && step!==0" style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green " class="btn btn-primary btn-submit-1 "

              @click="acceptComplete"
        >
          <div v-if="!status_loading">

            <span>  تایید </span>
          </div>
          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
        <a v-if="status && step!==0" style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
               @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span>عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>




    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import Input from "@/components/Impact_Assessment/mother/Input.vue";
import Photographer from "@/components/Impact_Assessment/mother/Photographer.vue";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  components: {
    Input,
    Photographer,

    Sidebar,
    splash
  },
  data(){
    return{
      modalMessageShowModal: false,
      modalMessageShow: '',
      status: true,
      id_route: this.$route['params']['id'],
      status_show: false,          // نمایش یا مخفی بودن یک وضعیت خاص
      status_loading: false,       // وضعیت لودینگ برای عملیات اول
      status_loading2: false,      // وضعیت لودینگ برای عملیات دوم
      infoCancelled: false,        // وضعیت کنسل شدن اطلاعات
      modalMessage: false,        // وضعیت کنسل شدن اطلاعات
      text_info: '',               // متن ورودی یا توضیحات
      step: 0,
    }
  },
  methods:{
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
        return
      }

    },
    result_company(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/result_company_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.step = response.step
            if (response.status){
              this.status_show = true
            }
            if (response.step && response.step ===2){
              this.step = response.step
            }

            if (response.message){
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
          })
          .catch();
    },


    acceptComplete(){
      if (this.step !== 2) {
        return;
      }
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update_complate_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.result_company()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/impact-assessment/update_complate_by_id/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              this.result_company()
            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update_complate_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.result_company()
            }
            this.infoCancelled = false

          })
          .catch();
    },



  },
  mounted() {
    this.result_company()

    this.checkIsMother()
  }

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 20vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(2.1vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>